import { Gift } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { LucideIcon } from '@/src/components/LucideIcon';
import Card from '@/src/components/features/property/ui/Card';
import { ReadMoreText } from '@/src/components/features/property/lib/ReadMoreText';
import { specialOfferBody, specialOfferHeading } from './specialOfferCard.styles';

type SpecialOfferCardProps = {
  description: string;
  collapseDescription?: boolean;
  className?: string;
};

export function SpecialOfferCard({ description, collapseDescription = true, className }: SpecialOfferCardProps) {
  const t = useTranslations('hdp');
  return (
    <Card variant="accent" size="md" className={className}>
      <div className={specialOfferHeading}>
        <LucideIcon icon={Gift} size="sm" />
        {t('specialOffer')}
      </div>
      <div className={specialOfferBody}>
        {collapseDescription ? (
          <ReadMoreText
            controlsId="cost-and-fees-special-offer-card"
            content={description}
            maxTruncatedLength={80}
            readMoreText={t('readMore')}
            readLessText={t('readLess')}
          />
        ) : (
          description
        )}
      </div>
    </Card>
  );
}
